import { render } from "./tHeader.vue?vue&type=template&id=417de280&scoped=true"
import script from "./tHeader.vue?vue&type=script&lang=js"
export * from "./tHeader.vue?vue&type=script&lang=js"

import "./tHeader.vue?vue&type=style&index=0&id=417de280&lang=less&scoped=true"

import exportComponent from "D:\\huiwu\\wgt_user_web_3.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-417de280"]])

export default __exports__